var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 880,
    height: 879,
    viewBox: "0 0 880 879",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.88 366.245C238.88 254.997 329.069 164.808 440.317 164.808C551.566 164.808 641.755 254.997 641.755 366.245C641.755 477.494 551.566 567.683 440.317 567.683C329.069 567.683 238.88 477.494 238.88 366.245Z",
    fill: "url(#paint0_linear_64_30)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.505 629.78C666.074 582.223 733.317 482.09 733.317 366.245C733.317 204.418 602.145 73.2451 440.317 73.2451C278.508 73.2451 147.317 204.418 147.317 366.245C147.317 482.108 214.561 582.259 312.148 629.799V787.433C312.148 790.748 313.047 794.001 314.751 796.845C316.454 799.69 318.898 802.018 321.822 803.582C324.745 805.146 328.038 805.887 331.349 805.726C334.661 805.565 337.866 804.509 340.624 802.669L440.317 736.194L540.029 802.669C542.787 804.509 545.992 805.565 549.304 805.726C552.615 805.887 555.908 805.146 558.832 803.582C561.755 802.018 564.199 799.69 565.902 796.845C567.606 794.001 568.505 790.748 568.505 787.433V629.78ZM440.317 622.62C581.91 622.62 696.692 507.837 696.692 366.245C696.692 224.653 581.91 109.87 440.317 109.87C298.725 109.87 183.942 224.653 183.942 366.245C183.942 507.837 298.725 622.62 440.317 622.62Z",
    fill: "url(#paint1_linear_64_30)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_30",
    x1: 128.716,
    y1: 147.184,
    x2: 371.913,
    y2: 451.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520674,
    stopColor: "#EBC540",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBC540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_30",
    x1: -12.9214,
    y1: 41.2027,
    x2: 440.313,
    y2: 494.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520674,
    stopColor: "#EBC540",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBC540"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.ea085da58fca8d5f3fbe6d243b2cbb69.svg";
export { ForwardRef as ReactComponent };